function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 7.97a.941.941 0 01-.298.726l-.67.639a1.03 1.03 0 01-.139.111l-4.45 4.263a1.08 1.08 0 01-1.475 0l-.67-.638a.934.934 0 01-.001-1.367L8.165 8 4.298 4.296a.934.934 0 010-1.367l.67-.639a1.08 1.08 0 011.475.001l4.455 4.266c.047.032.092.068.134.108l.67.64a.944.944 0 01.297.665z",
  fill: "currentColor"
})));